<template>
  <div class="card" :class="{'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <p v-if="errorMsg !== ''" class="error">{{errorMsg}}</p>
    <div class="card__container">
      <div class="surat" ref="surat">
        <div class="overlay overlay--alt" v-if="resultLoading">
          <div class="overlay__inner">
              <div class="overlay__content"><span class="spinner"></span></div>
          </div>
        </div>
        <div class="surat__header">
          <img src="/img/pemerintah-logo.png" alt="Logo Pemerintah IDP" />
          <div class="surat__title">
            <h1>PEMERINTAH KOTA #INDOPRIDE</h1>
            <h2>SEKERTARIAT DAERAH</h2>
            <p>Gedung Balaikota Jl. Galileo Observatory, Vinewood Hills</p>
            <h3>KOTA #INDOPRIDE</h3>
          </div>
          <img src="/img/idp-logo.png" alt="Logo IDP" />
        </div>
        <div class="line"></div>
        <div class="surat__body">
            <p class="surat__date">Vinewood Hills, {{getJakartaDate}}</p>
            <!-- <textarea ref="content" v-model="suratContent" id="content" :disabled="!enableEdit" class="surat__content"></textarea> -->
            <div class="surat__intro">
              <p><span class="surat__intro--title" :class="{'surat__intro--title-alt': suratTitle === 'Surat Keterangan Kematian'}">NO.</span>:  {{ nomorSurat }}</p>
              <p v-if="showSifat"><span class="surat__intro--title" :class="{'surat__intro--title-alt': suratTitle === 'Surat Keterangan Kematian'}">SIFAT</span>:  RAHASIA</p>
              <p><span class="surat__intro--title" :class="{'surat__intro--title-alt': suratTitle === 'Surat Keterangan Kematian'}">HAL</span>:  {{ suratTitle !== '' ? halSurat[suratTitle].hal : '' }}</p>
              <p v-if="suratTitle === 'Surat Keterangan Kematian'"><span class="surat__intro--title" :class="{'surat__intro--title-alt': suratTitle === 'Surat Keterangan Kematian'}">LAMPIRAN</span>:  1 (Satu) LEMBAR</p>
            </div>
            <div :contenteditable="enableEdit" ref="content" class="surat__content content_editable_element" @input="onInput"></div>
          <div class="surat__footer">
            <img src="/img/pemerintah-logo-sepia.png" alt="pemerintah logo sepia" class="surat__cap" />
            <div>
              <p class="surat__date">Vinewood Hills, {{getJakartaDate}}</p>
              <p class="surat__date">WALIKOTA KOTA#INDOPRIDE</p>
              <div style="text-align: right; margin-top: 0;">
                <img src="/img/TDD_PRIO_KUNCORO.png" alt="tanda tangan walikota" class="surat__tdd" />
              </div>
              <p class="surat__surname">Ir. Prio Kuncoro</p>
              <p class="surat__nik">NIK:1404270207199201</p>
            </div>
          </div>
        </div>
      </div>
      <div class="surat__button">
        <label for="title">Judul Surat</label>
        <!-- <input v-model="suratTitle" name="title" :disabled="!enableEdit" type="text" /> -->
        <select v-model="suratTitle" :disabled="query.get('action') !== null && query.get('action') === 'edit'">
          <option value="Surat Izin Opang"  v-if="!listDuplicateSurat.includes('Surat Izin Opang')">Surat Izin Opang</option>
          <option value="Surat Kartu Pekerja" v-if="!listDuplicateSurat.includes('Surat Kartu Pekerja')">Surat Kartu Pekerja</option>
          <option v-if="$store.state.user.roleId >= 3 && !listDuplicateSurat.includes('Surat Pergantian KTP')" value="Surat Pergantian KTP" >Surat Pergantian KTP</option>
          <option v-if="$store.state.user.roleId >= 3 && !listDuplicateSurat.includes('Surat Pencabutan Warga Negara')" value="Surat Pencabutan Warga Negara">Surat Pencabutan Warga Negara</option>
          <option v-if="$store.state.user.roleId >= 3 && !listDuplicateSurat.includes('Surat Izin Kegiatan')" value="Surat Izin Kegiatan">Surat Izin Kegiatan</option>
          <option v-if="$store.state.user.roleId >= 3 && !listDuplicateSurat.includes('Surat Keterangan Kematian')" value="Surat Keterangan Kematian">Surat Keterangan Kematian</option>
          <!-- <option v-if="$store.state.user.roleId >= 3" value="Sertifikat Hewan">Sertifikat Hewan</option> -->
        </select>
        <label v-if="suratTitle === 'Kosong'" for="suratTitle" style="margin-top: 20px">Judul Surat Custom</label>
        <input :disabled="!enableEdit" class="surat__input" v-if="suratTitle === 'Kosong'" v-model="suratTitleKosong" type="text" name="suratTitle" />
        <div class="nomor_surat_container">
          <label for="surat_nomor">No. Surat</label>
          <input :disabled="query.get('action') !== null && query.get('action') === 'edit'" name="surat_nomor" v-model="nomorSurat" />
        </div>
        <p v-if="query.get('action') === 'new'">Nomor Surat Terakhir: {{ nomorSuratTerakhir }}</p>
        <div class="button__container" v-if="suratTitle !== ''">
          <button v-show="!enableEdit" @click="editHandler()">Edit</button>
          <button v-show="enableEdit" :disable="contentUploading" class="save__button" @click="saveSuratHandler()">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SuratController from '../../Controller/SuratController.vue'
  import domtoimage from "dom-to-image-more";
  export default {
    extends: SuratController,
    data() {
      return {
        query: new URLSearchParams(window.location.search),
        enableEdit: false,
        suratContent: '',
        suratTitle: '',
        errorMsg: '',
        fileName: '',
        imgFile: '',
        contentUploading: false,
        resultLoading: false,
        suratTitleKosong: '',
        nomorSurat: '',
        listDuplicateSurat: [],
        halSurat: {
          'Surat Izin Opang': {
            hal: 'SURAT IJIN TRANSPORTASI WARGA'
          },
          'Surat Kartu Pekerja': {
            hal: 'KARTU PEKERJA'
          },
          'Surat Pergantian KTP': {
            hal: 'SURAT KETERANGAN PERGANTIAN KTP'
          },
          'Surat Pencabutan Warga Negara': {
            hal: 'SURAT PENCABUTAN WARGA NEGARA'
          },
          'Surat Izin Kegiatan': {
            hal: 'SURAT KEGIATAN'
          },
          'Surat Keterangan Kematian': {
            hal: 'SURAT KETERANGAN KEMATIAN'
          },
          'Sertifikat Hewan': {
            hal: 'SERTIFIKAT KEPEMILIKAN HEWAN'
          }
        },
        nomorSuratTerakhir: ''
      }
    },
    watch: {
      suratTitle(newVal) {
        if(this.query.get('action') !== null && this.query.get('action') !== 'edit') {
          this.resultLoading = true;
          this.getTemplateSurat(newVal)
            .then(data => {
              if(newVal === 'Kosong') {
                document.getElementsByClassName('surat__content')[0].innerHTML = '';
                this.resultLoading = false;
                return
              }
              if(data.result !== undefined && data.result.length !== 0) {
                this.suratContent = data.result[0].templateSurat;
                document.getElementsByClassName('surat__content')[0].innerHTML = this.suratContent
                this.handleImageUpload(newVal);
                this.resultLoading = false;
              } else {
                this.suratContent = '';
                this.resultLoading = false;
              }
            })
          
          this.getNomorSurat(this.suratTitle)
            .then(data => {
              if(data.result !== undefined && data.result.length !== 0) {
                this.nomorSuratTerakhir = data.result[0].nomorSurat;
              } else {
                this.nomorSuratTerakhir = '';
              }
            })
        } else if(this.query.get('action') !== null && this.query.get('action') === 'edit') {
          if(newVal === 'Sertifikat Hewan') {
            this.handleImageUpload(newVal);
            const image_input = document.querySelector("#image-input");
            if(this.query.get('action') !== 'edit') {
              image_input.style.display = 'block'
            } else {
              image_input.style.display = 'none'
            }
          }
        }
        this.$nextTick(() => this.$refs.content.focus({preventScroll: true}))
      },
    },
    mounted() {
      this.suratContent = '';
      // const textarea = document.querySelector('.surat__content');
      if(this.query.get('action') !== null && this.query.get('action') === 'new') {
        this.resultLoading = true;
        this.getSuratTitle(this.query.get('steamHex'))
          .then(data => {
            var listSurat = ['Surat Izin Opang', 'Surat Kartu Pekerja', 'Surat Pergantian KTP', 'Surat Pencabutan Warga Negara', 'Surat Izin Kegiatan', 'Surat Keterangan Kematian']
            var listSuratStaff = ['Surat Izin Opang', 'Surat Kartu Pekerja']
            this.listDuplicateSurat = [];
            data.forEach(obj => {
              this.listDuplicateSurat.push(obj.surattitle)
            });
            listSurat  = listSurat.filter(suratTitle => {
              return !this.listDuplicateSurat.includes(suratTitle)
            });
            listSuratStaff = listSuratStaff.filter(suratTitle => {
              return !this.listDuplicateSurat.includes(suratTitle);
            })
            console.log(this.$store.state.user.roleId < 3)
            if(listSurat.length > 0 && this.$store.state.user.roleId >= 3) {
              this.suratTitle = listSurat[0]
            } else if(listSuratStaff.length > 0 && this.$store.state.user.roleId < 3) {
              this.suratTitle = listSuratStaff[0]
            } 
            else {
              this.suratTitle = '';
            }
            this.enableEdit = true;
          })
          .catch(err => {
            this.errorMsg = '';
            this.errorMsg = err;
            console.error(err);
          })
        if(this.suratTitle !== '') {
          this.getTemplateSurat(this.suratTitle)
          .then(data => {
            if(data.result !== undefined && data.result.length !== 0) {
              this.suratContent = data.result[0].templateSurat;
              document.getElementsByClassName('surat__content')[0].innerHTML = this.suratContent
              this.$nextTick(() => this.$refs.content.focus({preventScroll: true}))
              this.resultLoading = false;
            } else {
              this.suratContent = '';
            }
          })
          this.getNomorSurat(this.suratTitle)
            .then(data => {
              if(data.result !== undefined && data.result.length !== 0) {
                this.nomorSuratTerakhir = data.result[0].nomorSurat;
              }
            })
          this.enableEdit = true;
        }
        this.resultLoading = false;
      } else if (this.query.get('action') !== null && this.query.get('action') === 'edit') {
        this.resultLoading = true;
        this.getSurat(null, this.query.get('surat_id'), this.query.get('surattitle'))
          .then(data => {
            this.suratContent = data.result[0].suratContent;
            
            // if(data.result[0].isEmpty) {
            //   this.suratTitle = data.result[0].surattitle;
            // } else {
            //   this.suratTitle = 'Kosong';
            //   this.suratTitleKosong = data.result[0].surattitle;
            // }
            this.suratTitle = data.result[0].surattitle;
            this.nomorSurat = data.result[0].nomorSurat
            document.getElementsByClassName('surat__content')[0].innerHTML = this.suratContent
            this.resultLoading = false;
          })
      } else {
        this.suratContent = '';
      }
    },
    methods: {
      async print() {
        this.resultLoading = false;
        console.log('printing...')
        const el = this.$refs.surat;
        await domtoimage.toPng(el).then((dataUrl) => {
            this.sendImage(dataUrl, this.suratTitle, this.nomorSurat)
          })
      } ,
      handleImageUpload(newVal) {
        if(newVal === 'Sertifikat Hewan') {
          const image_input = document.querySelector("#image-input");
          image_input.addEventListener("change", (e) => {
            this.contentUploading = true;
            const reader = new FileReader();
            reader.addEventListener("load", () => {
              const uploaded_image = reader.result;
              document.getElementById("display-image").src = `${uploaded_image}`;
              document.getElementById("display-image").style.display = 'block';
              this.suratContent = document.getElementsByClassName('surat__content')[0].innerHTML
              this.imgFile = uploaded_image;
              this.contentUploading = false;
            });
            reader.readAsDataURL(e.target.files[0]);
            var fileInput = document.getElementById('image-input'); 
            if(fileInput.files.length !== 0) {
              const name = fileInput.files[0].name;
              this.fileName = name;
            }
          });
        }
      },
      onInput(e) {
        if (e.keyCode === 13) {
          // insert 2 br tags (if only one br tag is inserted the cursor won't go to the next line)
          document.execCommand('insertHTML', false, '\n');
          // prevent the default behaviour of return key pressed
          e.preventDefault();
        } else {
          this.suratContent = e.target.innerHTML
        }
        

      },
      async saveSuratHandler() {
        const steamHex = this.query.get('steamHex') !== null ? this.query.get('steamHex') : ''
        const image_input = document.querySelector("#image-input");
        if(steamHex !== '' && this.query.get('action') === 'new' && this.query.get('warga_firstname') !== null && this.query.get('warga_lastname') != null) {
          this.resultLoading = true;
          const wargaFirstname = this.query.get('warga_firstname');
          const wargaLastname = this.query.get('warga_lastname');
          if(this.suratTitle !== 'Sertifikat Hewan') {
            if(this.nomorSurat !== '') {
              this.saveSurat(steamHex, this.suratContent, this.suratTitle, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.nomorSurat, wargaFirstname, wargaLastname)
                .then(async (data) => {
                  this.errorMsg = '';
                  if(data.msg !== undefined) {
                    this.errorMsg = data.msg
                  } else {
                    this.enableEdit = false;
                    this.$router.replace({path: this.$route.path, query: {'action': 'edit','surat_id': data.result.insertId, 'steamHex': steamHex, 'surattitle': this.suratTitle}})
                      .then(() => {
                        this.query = new URLSearchParams(window.location.search)
                      })
                    this.resultLoading = false;
                    await this.print();
                  }
                })
            } else {
              // this.saveSurat(steamHex, this.suratContent, this.suratTitleKosong, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.suratTitle)
              //   .then(data => {
              //     if(data.msg !== undefined) {
              //       this.errorMsg = data.msg
              //     } else {
              //       this.print()
              //       this.enableEdit = false;
              //       this.$router.replace({path: this.$route.path, query: {'action': 'edit','surat_id': data.result.insertId, 'steamHex': steamHex}})
              //         .then(() => {
              //             this.query = new URLSearchParams(window.location.search)
              //           })
              //       this.resultLoading = false;
              //     }
              //   })
              this.errorMsg = 'Silahkan masukan nomor surat!';
              this.resultLoading = false;
            }
            
          } else {
            const image_input = document.querySelector("#image-input");
            image_input.style.display = 'none'
            await this.print()
            if(this.fileName === '') {
              const image_input = document.querySelector("#image-input");
              image_input.style.display = 'none'
              this.saveSuratHewan(steamHex, this.suratContent, this.suratTitle, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.imgFile, this.fileName)
                .then(data => {
                  if(data.msg !== undefined) {
                    this.errorMsg = data.msg
                  } else {
                    this.enableEdit = false;
                    this.$router.replace({path: this.$route.path, query: {'action': 'edit','surat_id': data.result.insertId, 'surattitle': this.suratTitle}})
                      .then(() => {
                        this.query = new URLSearchParams(window.location.search)
                      })
                    this.resultLoading = false;
                  }
                })
            } else {
              const path = process.env.NODE_ENV === 'production' ? `/img/${this.fileName}` : `http://localhost:5000/img/${this.fileName}`
              document.getElementById("display-image").src = path
              this.suratContent = document.getElementsByClassName('surat__content')[0].innerHTML
              this.saveSuratHewan(steamHex, this.suratContent, this.suratTitle, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.imgFile, this.fileName)
                .then(data => {
                  if(data.msg !== undefined) {
                    this.errorMsg = data.msg
                  } else {
                    this.enableEdit = false;
                    this.$router.replace({path: this.$route.path, query: {'action': 'edit','surat_id': data.result.insertId, 'steamHex': steamHex}, 'surattitle': this.suratTitle})
                      .then(() => {
                          this.query = new URLSearchParams(window.location.search)
                        })
                    this.resultLoading = false;
                  }
                })
            }
          }
          
        } else if(this.query.get('action') !== null && this.query.get('action') === 'edit') {
          const steamHex = this.query.get('steamHex') !== null ? this.query.get('steamHex') : ''
          this.resultLoading = true;
          if(this.suratTitle !== 'Sertifikat Hewan') {
            if(this.suratTitle !== 'Kosong') {
              this.editSurat(steamHex, this.suratContent, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.query.get('surat_id'), this.suratTitle)
              .then(async (data) => {
                if(data.msg !== undefined) {
                  this.errorMsg = data.msg
                } else {
                  this.enableEdit = false;
                  this.resultLoading = false;
                  await this.print();
                }
              })
            } else {
              this.editSurat(steamHex, this.suratContent, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.query.get('surat_id'), this.suratTitleKosong, this.suratTitle)
              .then(async (data) => {
                if(data.msg !== undefined) {
                  this.errorMsg = data.msg
                } else {
                  this.enableEdit = false;
                  this.resultLoading = false;
                  this.print();
                }
              })
            }
          } else {
            if(this.fileName === '') {
              this.editSuratHewan(steamHex, this.suratContent, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.imgFile, this.fileName, this.query.get('surat_id'))
              .then(async (data) => {
                if(data.msg !== undefined) {
                  this.errorMsg = data.msg
                } else {
                  this.enableEdit = false;
                  this.resultLoading = false;
                  image_input.style.display = 'none';
                  await this.print();
                }
              })
            } else {
              const path = process.env.NODE_ENV === 'production' ? `/img/${this.fileName}` : `http://localhost:5000/img/${this.fileName}`
              document.getElementById("display-image").src = path
              this.suratContent = document.getElementsByClassName('surat__content')[0].innerHTML
              this.editSuratHewan(steamHex, this.suratContent, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.imgFile, this.fileName, this.query.get('surat_id'))
              .then(async (data) => {
                if(data.msg !== undefined) {
                  this.errorMsg = data.msg
                } else {
                  this.enableEdit = false;
                  this.resultLoading = false;
                  image_input.style.display = 'none';
                  await this.print();
                }
              })
            }
          }
          this.enableEdit = false;
        } 
        else {
          this.errorMsg = 'Steam hex tidak terdeteksi di dalam url';
        }
      },
      editHandler() {
        const image_input = document.querySelector("#image-input");
        this.enableEdit = !this.enableEdit;
        this.query = new URLSearchParams(window.location.search)
        if(this.suratTitle === 'Sertifikat Hewan') {
          image_input.style.display = 'block';
        }
        
        this.$nextTick(() => this.$refs.content.focus({preventScroll: true}))
      }
    },
    computed: {
      getJakartaDate() {
        const jakartaDate = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Jakarta"}));
        var month;
        switch(jakartaDate.getMonth() + 1) {
          case 1:
            month = 'Januari'
            break;
          case 2:
            month = 'Februari'
            break;
          case 3:
            month = 'Maret'
            break;
          case 4:
            month = 'April'
            break;
          case 5:
            month = 'Mei'
            break;
          case 6:
            month = 'Juni'
            break;
          case 7:
            month = 'Juli'
            break;
          case 8:
            month = 'Agustus'
            break;
          case 9:
            month = 'September'
            break;
          case 10:
            month = 'Oktober'
            break;
          case 11:
            month = 'November'
            break;
          case 12:
            month = 'Desember'
            break;
        }

        return jakartaDate.getDate() + ' ' + month + ' ' + jakartaDate.getFullYear(); 
      },
      showSifat() {
        if(this.suratTitle !== 'Surat Izin Opang' && this.suratTitle !== 'Surat Kartu Pekerja' && this.suratTitle !== 'Sertifikat Hewan') {
          return true;
        } else {
          return false;
        }
      }
    }
  }
</script>

<style scoped>
  .card__container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    padding-bottom: 0;
    min-height: 850px;
  }
  .surat {
    min-width: 563px;
    max-width: 563px;
    min-height: 750px;
    max-height: 750px;
    background-color: white;
    position: relative;
    padding: 20px;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    display: flex;
    flex-direction: column;
  }
  .surat__header {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .surat__header img {
    width: 84px;
  }
  .surat__title {
    color: black;
    text-align: center;
    line-height: 23px;
  }
  .surat__title h1 {
    font-size: 1.2em;
    font-weight: bold;
    color: black;
  }
  .surat__title h2 {
    font-size: 1.2em;
    font-weight: bold;
    margin: 0;
    color: black;
  }
  .surat__title p {
    font-size: 0.8em;
    color: black;
  }
  .surat__title h3 {
    font-weight: 700;
    color: black;
  }
  .line {
    border: solid 1px black;
    width: 80%;
    margin: 10px auto;
    color: black;
  }
  .surat__body {
    width: 80%;
    margin: 0 auto;
    height: 100%;
    color: black;
  }
  .surat__date {
    text-align: right;
    font-size: 10px;
    margin-bottom: 5px;
    color: black;
  }
  .surat__content {
    border: none;
    height: fit-content;
    min-height: 70%;
    width: 95%;
    padding: 10px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 10px;
    resize: none;
    max-height: 55%;
    color: black;
    height: 370px;
  }
  .surat__tdd {
    width: 250px;
    margin-top: 15px;
  }
  .surat__surname {
    text-align: right;
    margin-top: 15px;
    color: black;
    font-size: 11px;
  }
  .surat__footer {
    position: relative;
  }
  .surat__footer div {
    position: relative;
    z-index: 2;
    margin-top: 30px;
  }
  .surat__cap {
    width: 150px;
    opacity: 0.5;
    transform: rotate(-15deg);
    position: absolute;
    z-index: 1;
    right: 140px;
    top: -15px;
  }
  .surat__button {
    min-height: 750px;
    display: flex;
    flex-direction: column;
  }
  .surat__button select {
    background: transparent;
    border: none;
    border-bottom: solid 1px white;
    color: white;
    margin-top: 10px;
    min-width: 250px;
    font-size: 1.1em;
  }
  .surat__button option {
    background: #003D19
  }
  .button__container {
    display: flex;
    justify-content: flex-end;
  }
  .button__container button:last-child {
    margin-right: 0;
  }
  .surat__content:disabled {
    background: white;
  }
  .content_editable_element {
    white-space: pre-wrap;       /* css-3 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
  }
  .content_editable_element br {
    display: none;
  }
  [contenteditable="true"]{display: inline-block;}
  .surat__content div {
    font-weight: 700;
  }
  .surat__content input {
    display: none;
  }
  .surat__button input {
    padding: 0;
    width: 100%;
  }

  .surat__nik {
    color: black;
    text-align: right;
    font-size: 11px;
    margin-top: 5px;
  }

  .nomor_surat_container {
    margin-top: 20px;
  }

  .surat__intro p {
    color: black;
    font-size: 10px;
    padding: 0 10px;
    margin: 0
  }

  .surat__intro--title {
    width: 40px;
    color: black;
    display: inline-block;
  }

  .surat__intro--title-alt {
    width: 70px;
  }
</style>